<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Deal"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">

              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Contact Person <span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="contactName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="dealCloseDate" >Company Name<span style="color:red">*</span></label>
                <InputText id="dealCloseDate" v-model.trim="companyName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="dealStage" >Deal Name<span style="color:red">*</span></label>
                <InputText id="dealStage" v-model.trim="dealName" />
              </div>
              
              <div class="p-field p-col-12 p-md-6">
                <label for="amount" >Deal Value</label>
                <InputText @keypress="isNumber($event)" v-model="amount" id="amount"/>
              </div>

               <div class="p-field p-col-12 p-md-6">
                <label for="expectedRevenue" >Expected Revenue</label>
                <InputText @keypress="isNumber($event)" v-model="expectedRevenue" id="expectedRevenue"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="source">Source</label>
                <Dropdown 
                  id="source" 
                  v-model="leadSourceId" 
                  :options="sourceList" 
                  optionLabel="value" 
                  placeholder="Select Source" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="source">Stage</label>
                <Dropdown 
                  id="source" 
                  v-model="dealStage" 
                  :options="stageList" 
                  optionLabel="value" 
                  placeholder="Select Stage" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="probability" >Probability</label>
                <InputText v-model.trim="probability" id="probability" />
              </div>

             <div class="p-field p-col-12 p-md-6">
              <label for="dealOpenDate" >Deal Open Date</label>
              <InputMask mask="9999-99-99" type="text" v-model.trim="dealOpenDate" id="dealOpenDate"/>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <label for="dealCloseDate" >Expected Close Date</label>
              <InputMask mask="9999-99-99" type="text" v-model.trim="dealCloseDate" id="dealCloseDate"/>
            </div>


            <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <Textarea id="description" rows="3" v-model="description"/>
              </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button" @click.prevent="addDeal" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewDeal" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Textarea from 'primevue/textarea/Textarea'
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
export default {
  name: 'supplier',
  data() {
    return {
      contactName: '',
      dealStage: null,
      leadSourceId: null,
      dealOpenDate: '',
      dealCloseDate: '',
      probability: '',
      expectedRevenue: '',
      amount: '',
      description: '',
      companyName: '',
      dealName: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      createUser: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      columnList: '',
      filters: {}
    }
  },
  mounted() {
    this.masterSetupLists()
  },
  computed: {
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    sourceList() {
      return this.masterSetupList.filter(item =>
        item.name === 'source'
      )
    },
    stageList() {
      return this.masterSetupList.filter(item =>
        item.name === 'stage'
        )
    }
  },
  methods: {
    async addDeal() {
      if (this.contactName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contactName cannot be empty!', life: 10000})
        return
      }
      if (this.companyName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'companyName cannot be empty!', life: 10000})
        return
      }
      if (this.dealName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'dealName cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        contactName: this.contactName,
        companyName: this.companyName,
        dealName: this.dealName,
        amount: this.amount,
        expectedRevenue: this.expectedRevenue,
        dealStage: this.dealStage.id,
        probability: this.probability,
        dealOpenDate: this.dealOpenDate,
        dealCloseDate: this.dealCloseDate,
        description: this.description,
        leadSourceId: this.leadSourceId.id
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmDeal', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmDeal', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewDeal() {
      if (this.contactName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contactName cannot be empty!', life: 10000})
        return
      }
      if (this.companyName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'companyName cannot be empty!', life: 10000})
        return
      }
      if (this.dealName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'dealName cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        contactName: this.contactName,
        companyName: this.companyName,
        dealName: this.dealName,
        amount: this.amount,
        expectedRevenue: this.expectedRevenue,
        dealStage: this.dealStage.id,
        probability: this.probability,
        dealOpenDate: this.dealOpenDate,
        dealCloseDate: this.dealCloseDate,
        description: this.description,
        leadSourceId: this.leadSourceId.id
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmDeal', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    editDeal(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.contactName = data.contactName
      this.dealName = data.dealName
      this.companyName = data.companyName
      this.leadSourceId = this.sourceList.find(item => item.id === data.leadSourceId)
      this.amount = data.amount
      this.dealOpenDate = data.dealOpenDate
      this.dealCloseDate = data.dealCloseDate
      this.probability = data.probability
      this.expectedRevenue = data.expectedRevenue
      this.dealStage = this.stageList.find(item => item.id === data.dealStage)
      this.description = data.description
      this.openAddDialog()
    },
    reset() {
      this.contactName = ''
      this.companyName = ''
      this.dealName = ''
      this.dealStage = null
      this.leadSourceId = null
      this.dealOpenDate = ''
      this.dealCloseDate = ''
      this.probability = ''
      this.expectedRevenue = ''
      this.status = ''
      this.amount = ''
      this.description = ''
      this.licenseExpireDate = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmDealDetailsDialog.vue?8b70f5ec